import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CircularProgress, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

interface Shop {
    fullName: string,
    address: string,
    logo: string,
    subscriptionPlan: string,
    isSubscribed: string,
    email: string,
    phone: string,
    paymentStatus: string,
    nextSubscriptionDate: string;
    storename: string;
    ticketslocation: string;
};

const shopIntialData = {
    fullName: "",
    address: "",
    logo: "",
    subscriptionPlan: "",
    isSubscribed: "",
    email: "",
    phone: "",
    paymentStatus: "",
    nextSubscriptionDate: "",
    storename: "",
    ticketslocation: ""
}

const ViewShopRenderer: React.FC = () => {

   //@ts-ignore
   const config = window.config;
   const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
   const { t } = useTranslation('translation');
   const [shopDetails, setShopDetails] = useState<Shop>(shopIntialData);
   const [imageLoading, setImageLoading] = useState(true);
   const { id } = useParams();

   useEffect(()=>{
    getParticularTicketDetails();
   },[]);

   const getParticularTicketDetails = () => {
    axios.get(`${apiBaseURL}/api/shop/fetchParticularShopDetail?id=${id}`).then((data: any) => {
    if(data?.status == 200){
        let shopDetail = data?.data?.shopDetails;
        let subscriptionDetail = data?.data?.subscriptionDetails;
        setShopDetails({
            fullName: shopDetail?.fullName,
            address: shopDetail?.address,
            logo: shopDetail?.logo,
            subscriptionPlan: subscriptionDetail?.subscriptionId,
            nextSubscriptionDate: subscriptionDetail?.nextSubscriptionDate,
            paymentStatus: subscriptionDetail?.paymentStatus,
            isSubscribed: subscriptionDetail?.isSubscribed,
            email: shopDetail?.email,
            phone: shopDetail?.phone,
            storename: shopDetail?.storename,
            ticketslocation: shopDetail?.ticketslocation
        });
    }
    }).catch((err: any) => {
        console.log("err", err)
    }).finally(() => {
    })
   }

   const onLoad = () => {
    setImageLoading(false);
  };

  return (
   <Grid className='h-screen bg-white p-[2%] relative font-["Baloo-2"]'>
            <Grid>
                <Grid className='text-[#daa520]'>{t('shopInformation')}</Grid>
                <Grid className='grid grid-cols-2 mt-1 gap-12'>
                    <Grid className='col-span-1'>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('fullname')}</Grid>
                            <Grid>{shopDetails?.fullName}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('address')}</Grid>
                            <Grid>{shopDetails?.address}</Grid>
                        </Grid>
                        <Grid className={shopDetails?.logo ? "my-2" : "grid grid-cols-2 gap-x-16 my-2"}>
                            <Grid className='col-span-1 font-[600]'>{t('image')}</Grid>
                            <Grid
                                item
                                xs={6}
                                className={shopDetails?.logo ? 'h-[140px] w-1/2' : ''}
                            >
                            {shopDetails?.logo ?
                                <img
                                    src={shopDetails?.logo}
                                    className='w-full aspect-square object-cover rounded-[5%] mt-2'
                                    onLoad={onLoad}
                                /> : (imageLoading ? "" : "-")
                            }
                            </Grid>
                        </Grid>
                        <Grid className='mt-4'>
                            {imageLoading && (
                                <CircularProgress
                                    color='inherit'
                                    size={14}
                                    thickness={6}
                                    style={{ marginLeft: "10%" }}
                                />
                                )}
                        </Grid>
                    </Grid>
                    <Grid className='col-span-1'>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('phone')}</Grid>
                            <Grid>{shopDetails?.phone}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('subscriptionPlan')}</Grid>
                            <Grid>{shopDetails?.subscriptionPlan}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('nextSubscriptionDate')}</Grid>
                            <Grid>{shopDetails?.nextSubscriptionDate}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('subscribed')}</Grid>
                            <Grid>{shopDetails?.isSubscribed ? "True" : ""}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('email')}</Grid>
                            <Grid>{shopDetails?.email}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('paymentStatus')}</Grid>
                            <Grid>{shopDetails?.paymentStatus}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('storeName')}</Grid>
                            <Grid>{shopDetails?.storename}</Grid>
                        </Grid>
                        <Grid className='grid grid-cols-2 gap-x-16 my-2'>
                            <Grid className='col-span-1 font-[600]'>{t('ticketsLocation')}</Grid>
                            <Grid>{shopDetails?.ticketslocation}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
  )
}

export default ViewShopRenderer;